/* Keep vendor navigation native; show guidance without claiming to monitor the external app. */
(() => {
  const dialog = document.getElementById('DeckDesignLaunch');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const launch = dialog.querySelector('[data-deck-launch]');
  let trigger;

  function isDeckLink(link) {
    if (!link || dialog.contains(link)) return false;
    try {
      const url = new URL(link.href);
      return url.protocol === 'https:' && url.hostname === 'deckstorestaging.chameleonpower.com';
    } catch (_) {
      return false;
    }
  }

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || !isDeckLink(link)) return;
    event.preventDefault();
    trigger = link;
    launch.href = link.href;
    if (!dialog.open) dialog.showModal();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const controls = Array.from(dialog.querySelectorAll('button, a[href]'));
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  dialog.querySelector('[data-deck-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    if (trigger?.isConnected) trigger.focus({ preventScroll: true });
  });
})();
